import axios from '../api.js';
import * as config from '../config.js';

export default {

    // validate user as Admin/TC/Diagnostician
    validateUser: (userEmail) =>
        axios.get(config.baseURL + "validateWebUser/" + btoa(userEmail)),

    // get summary report data
    getemdedreportURL: (req, language) =>
        axios.get(config.baseURL + 'getEmbedConfigInfo/' + req + "/" + language),

    // update the report request
    insertActiveAPILog2: (params) =>
        axios.post(config.baseURL + 'insertActiveAPILog2', params),

    // get usage report data
    getUsageEmbedInfo: () =>
        axios.get(config.baseURL + 'getUsageEmbedInfo')
}
